import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RolCallCenter, RolUsuarioAplicacion } from '../hojas-call-center/models/RolCallCenter';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class RolService 
{

  //El fragmento para las llamadas a BD
  constructor(private http: HttpClient){}

  /*
    * La web service nos devolverá un array con los datos del rol ( o roles) 
    * que tiene un usuario en una aplicación.
    * 
    * Por ahora, solo se contempla que llegue un array con un solo rol.(rol[0])
    * 
    * @param token: token de autenticación
    * @param aplicacion: nombre de la aplicación
    * @param user: nombre del usuario/email
    * 
    * @return Promise<Array<any>>: array con los datos del rol (o roles) que tiene un usuario en una aplicación.
  */
  public getRolAplicationUser(token:string, aplicacion:string,user:string ): Promise<Array<RolUsuarioAplicacion>>
  {   
    let url:string = environment.wsRoleService+"/GetRole";
    let options = new HttpHeaders();
    options = options.set('Content-Type', 'application/json');
    options = options.set('Accept', 'application/json');
    options = options.set('Authorization', 'Bearer ' + token);
    
    if (!environment.production)
    {
      options = options.set('Access-Control-Allow-Origin', '*');
    }
    const httpOptions = 
    {
      headers: options,
      params: new HttpParams({})
    }
    let packeteEnvio = 
    {
      "aplication": aplicacion,
      "usuario": user
    }
    
    return new Promise<any>((resolve, reject) =>
      {
        this.http.post(url,packeteEnvio,httpOptions)
          .subscribe
          ({
            next:(response:any)=>resolve(response),
            error:(err)=>{reject(err)}
          });
      });
  }
}
